// main.js
import jQuery from 'jquery';
// import './navigation.js';
// import {SimpleLightbox} from "simplelightbox";
import './skip-link-focus-fix.js';
import List from 'list.js';


// window.jQuery = jQuery;

jQuery(document).ready(function() {

    // responsive navigation
        jQuery('body').addClass('js');
        var jQuerymenu = jQuery('.menu-main-navigation-container'),
        jQuerymenulink = jQuery('.menu-link');
    
        jQuerymenulink.on( 'click', function() {
            jQuerymenulink.toggleClass('active');
            jQuerymenu.toggleClass('active');
        return false;
        });




  /**
   *
   * Handles filtering on family direcotry & photo gallery pages
   * 
   */
  var options = {
      valueNames: [ 'dname', 'title', 'entry-meta', 'entry-title' ]
  };

  var listObj = new List('info-to-search', options);

  jQuery('#input-search').on('keyup', function() {
    var searchString = jQuery(this).val();
    listObj.search(searchString);
  });


  /**
   *
   * Handles back to top button
   * 
   */
  var btnTop = jQuery('#to-top');

  jQuery(window).scroll(function() {
    if (jQuery(window).scrollTop() > 300) {
      btnTop.addClass('show');
    } else {
      btnTop.removeClass('show');
    }
  });

  btnTop.on('click', function(e) {
    e.preventDefault();
    jQuery('html, body').animate({scrollTop:0}, '600');
  });





  /**
   *
   * Handles toggling the section navigation menu for small screens
   * 
   */

  function classToggle() {
    jQuery('#section-nav').toggleClass('expanded');
    jQuery('#section-menu-toggle').toggleClass('block');
  }
  jQuery('#section-menu-toggle').on('click', classToggle );


  


  // search overlay
  var searchMenu = jQuery('.search-form'),
  searchMenuLink = jQuery('.search-button');

  searchMenuLink.on( 'click', function() {
      searchMenuLink.toggleClass('active');
      searchMenu.toggleClass('active');
      searchMenu.append('<a href="#" class="closeBtn"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><polygon fill="#ffffff" fill-rule="evenodd" points="22.182 20 35.757 33.576 33.576 35.757 20 22.182 6.424 35.757 4.243 33.576 17.818 20 4.243 6.424 6.424 4.243 20 17.818 33.576 4.243 35.757 6.424"/></svg></a>');
  return false;
  });

  searchMenu.on( 'click', 'a.closeBtn' ,function(event) {
      event.preventDefault();
      searchMenuLink.toggleClass('active');
      searchMenu.toggleClass('active');
      // return false;
  });







/**
 *
 * Handles lightbox feature
 * 
 */
// jQuery('figure a').simpleLightbox({
//     captions: true,
//     captionDelay: 0,
//     captionSelector: 'img',
//     captionType: 'attr',
//     captionsData: 'alt',
//     captionPosition: 'bottom'
// });

// new SimpleLightbox('figure a', { 
//   captions: true,
//   captionDelay: 0,
//   captionSelector: 'img',
//   captionType: 'attr',
//   captionsData: 'alt',
//   captionPosition: 'bottom'
// });


}); // end doc.ready
